import { Dialog, DialogContent, DialogTitle } from "@material-ui/core";
import React from "react";
import OtpInput from "react-otp-input";
import DialogActions from "@material-ui/core/DialogActions";
import Button from "@material-ui/core/Button";
import "./index.less";

export default function OtpDialog({
  numInputs = 4,
  isDisabled = false,
  onResend = () => {},
  onSubmit = () => {},
  otpMessage,
  encodedEmail
}) {
  const [otp, setOtp] = React.useState("");

  /** resend otp function */
  function resentOtp() {
    setOtp("");
    onResend();
  }

  return (
    <Dialog
      fullScreen={false}
      open
      onClose={() => {}}
      aria-labelledby={"otp-dialog-title"}
      className={"otp-dialog"}
    >
      <DialogTitle id={"responsive-dialog-title1"}>
        {"Enter Verification Code\r"}
      </DialogTitle>
      <DialogContent>
        <p>{otpMessage}</p>
        <p>{encodedEmail}</p>
        <div className={"view"}>
          <div className={"card"}>
            <form>
              <div className={"margin-top--small"}>
                <OtpInput
                  value={otp}
                  onChange={otp => setOtp(otp)}
                  numInputs={numInputs}
                  separator={<span>{"-"}</span>}
                  isDisabled={isDisabled}
                />
              </div>
            </form>
          </div>
        </div>
      </DialogContent>
      <DialogActions>
        <Button autoFocus onClick={() => setOtp("")} color={"primary"}>
          {"Clear\r"}
        </Button>
        <Button onClick={resentOtp} color={"primary"} autoFocus>
          {"Resend\r"}
        </Button>
        <Button onClick={() => onSubmit(otp)} color={"primary"} autoFocus>
          {"Submit\r"}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
